// extracted by mini-css-extract-plugin
export default {"body":"DefaultLayout_body__Jytvv","pixel":"DefaultLayout_pixel__xF0lx"};